module.exports = __webpack_public_path__ + "static/media/facebook-logo.564bef1e.svg";